export default function ProjectTitle(props) {
    return (
        <div className={`col-span-full md:col-end-4 md:top-[5em] text-zinc-100 ${props.notSticky ? '' : 'md:sticky'}`}>
            <h1 className="font-workbench text-4xl font-bold text-[#424243] dark:text-white">{props.children}</h1>
            <p className="font-code font-light text-lg whitespace-nowrap text-[#424243] dark:text-white" style={{ fontVariant: 'small-caps' }}>{props.role}</p>
        </div>
    );
}